import React from "react";

type Props = {
  toggleLoading: boolean;
  isPrivate: boolean;
  onToggle?: (newValue: boolean) => void;
  enabled?: boolean;
  color: {
    textInputBackground: string;
    appTextColor: string;
  };
};

const ProfilePrivacyToggle: React.FC<Props> = ({
  toggleLoading,
  isPrivate,
  onToggle,
  enabled = false,
  color,
}) => {
  const handlePress = () => {
    if (enabled && onToggle) {
      onToggle(!isPrivate);
    }
  };

  const label = isPrivate ? "Private Profile" : "Public Profile";

  return (
    <button
      onClick={handlePress}
      disabled={!enabled || toggleLoading}
      className={`
        w-full py-2 bg-gray-600 text-white rounded-md 
        hover:bg-gray-700 transition-all duration-200
        flex items-center justify-center px-4 relative
        ${
          enabled && !toggleLoading
            ? "cursor-pointer"
            : "cursor-not-allowed opacity-60"
        }
        ${toggleLoading ? "hover:bg-gray-600" : ""}
      `}
    >
      {toggleLoading ? (
        <div className="flex-1 flex justify-center items-center py-1">
          <svg
            className="animate-spin h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
      ) : (
        <>
          {/* Perfectly centered label */}
          <span
            className="absolute inset-0 flex items-center justify-center pointer-events-none font-medium"
            style={{ color: color?.appTextColor }}
          >
            {label}
          </span>

          {/* Toggle switch fixed on the right */}
          <div className="relative z-10 ml-auto">
            <div
              className={`w-11 h-6 rounded-full transition-colors duration-300 ease-in-out ${
                isPrivate ? "bg-red-800" : "bg-gray-700"
              }`}
            >
              <div
                className={`
                  absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-md 
                  transform transition-transform duration-300 ease-in-out border
                  ${
                    isPrivate
                      ? "translate-x-5 border-gray-700"
                      : "translate-x-0 border-red-800"
                  }
                `}
              />
            </div>
          </div>
        </>
      )}
    </button>
  );
};

export default ProfilePrivacyToggle;
